import { StyleSheet } from 'react-native'

const useStyles = (isTablet) => StyleSheet.create({
  inputs: {
    flexDirection: isTablet ? 'row' : 'column'
  },
  rigthInput: {
    flex: 1,
    marginLeft: isTablet ? 5 : 0
  },
  leftInput: {
    flex: 1,
    marginRight: isTablet ? 5 : 0
  },
  buttonsContainer: {
    width: '100%',
    flexDirection: isTablet ? 'row' : 'column',
    justifyContent: 'space-between'
  },
  button: {
    minWidth: 120
  },
  divider: {
    marginBottom: 20
  }
})

export default useStyles
